export const FLAGS = {
    EC_EXIBE_REFEICAO: 'EC_EXIBE_REFEICAO',
    EC_EXIBE_ALIMENTACAO: 'EC_EXIBE_ALIMENTACAO',
    EC_EXIBE_CULTURA: 'EC_EXIBE_CULTURA',
    EC_EXIBE_ALELO_POD: 'EC_EXIBE_ALELO_POD',
    EC_EXIBE_ALELO_TUDO: 'EC_EXIBE_ALELO_TUDO',
    EC_EXIBE_NATAL: 'EC_EXIBE_NATAL',
    EC_EXIBE_DESPESAS: 'EC_EXIBE_DESPESAS',
    EC_EXIBE_GO_COMB: 'EC_EXIBE_GO_COMB',
    EC_EXIBE_PAGAMENTOS: 'EC_EXIBE_PAGAMENTOS',
    EC_EXIBE_VT: 'EC_EXIBE_VT',
    EC_EXIBE_PREMIACAO: 'EC_EXIBE_PREMIACAO',
    EC_EXIBE_VELOE_PEDAGIO: 'EC_EXIBE_VELOE_PEDAGIO',
    SEGREGACAO_CNPJ: 'SEGREGACAO_CNPJ'
}
